import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { TaskDetailView } from "@/components/tasks/TaskDetailView";
import { useTask } from "@/hooks/useTask";
import { useTaskWrites } from "@/hooks/useTaskWrites";

export const Route = createFileRoute("/_authenticated/tasks_/$taskId")({
  component: TaskDetailRoute,
});

/**
 * Detail page for a single task, reached by clicking a row on `/tasks`.
 * The `tasks_` segment escapes route nesting — this is a sibling full
 * page, not a child outlet of the list. Reads via `useTask`; the
 * complete/decision write affordances relay through `useTaskWrites`.
 */
function TaskDetailRoute() {
  const { taskId } = Route.useParams();
  const { task, isLoading } = useTask(taskId);
  const { completeTask, resolveDecision, pendingByTaskId, errorByTaskId } =
    useTaskWrites();
  const navigate = useNavigate();

  return (
    <div className="min-h-[calc(100vh-3.5rem)] bg-home-cream px-4 py-8 font-body text-home-ink md:py-10 lg:min-h-screen dark:bg-surface-dark dark:text-white">
      <TaskDetailView
        task={task}
        isLoading={isLoading}
        onBack={() => void navigate({ to: "/tasks" })}
        onComplete={() => void completeTask({ taskId })}
        onResolveDecision={(answer) =>
          void resolveDecision({ taskId, answer })
        }
        pendingWrite={pendingByTaskId.has(taskId)}
        relayError={errorByTaskId.get(taskId) ?? null}
      />
    </div>
  );
}
